export const INDUSTRIES_REQUEST = 'gustav/industries/FETCH_REQUEST';
export const INDUSTRIES_SUCCESS = 'gustav/industries/FETCH_SUCCESS';
export const INDUSTRIES_ERROR = 'gustav/industries/FETCH_ERROR';
